export const externalRedirect = (url: string): void => {
  window.location.href = url;
};
